import type { CopilotSettingsUserFilter$key } from "~/__generated__/CopilotSettingsUserFilter.graphql";
import type {
	AutoRecordRuleFilterOrganizer,
	AutoRecordRuleLevel,
	AutoRecordRuleType,
	FilterAttendeeType,
} from "~/__generated__/CreateAndEditModalCreateRuleMutation.graphql";
import type { RuleConfigurationStepUserPill$key } from "~/__generated__/RuleConfigurationStepUserPill.graphql";
import type { UserSelectionStepGetIncludesString$key } from "~/__generated__/UserSelectionStepGetIncludesString.graphql";

export enum CreationSteps {
	USER_SELECTION = 0,
	RULE_CONFIGURATION = 1,
}

/**
 * These are all of the required fragments for usage throughout the creation and update modals.
 * The ids of each user are also required for the mutation that will be used to create or update the rule.
 */
type UserNode = UserSelectionStepGetIncludesString$key &
	CopilotSettingsUserFilter$key &
	RuleConfigurationStepUserPill$key &
	UserSelectionStepGetIncludesString$key & {
		readonly id: string;
	};

/**
 * The user input represents a user that is selected to be included in the rule.
 * It includes a mutable flag to include all reports for the user as well as a union of fragment keys for usage throughout the modal.
 * A null user input represents a user that has not been selected yet.
 */
export type UserInput = {
	user: UserNode;
	includeAllReports: boolean;
} | null;

/**
 * A rule input represents all of the mutable fields that are required to create or update a rule.
 */
export interface RuleInput {
	id?: string;
	ruleType: AutoRecordRuleType;
	autoRecordRuleUsers: UserInput[];
	ruleLevel: AutoRecordRuleLevel;
	filterAttendeeType: FilterAttendeeType;
	filterOrganizer: AutoRecordRuleFilterOrganizer;
	filterMinimumAttendees?: number;
	filterMaximumAttendees?: number;
	filterKeywordsContains: string[];
	filterKeywordsRestrict: string[];
}
